// extracted by mini-css-extract-plugin
export default {"spinner":"wOiVm","numberInput":"km4h6","controls":"ZC5Md","legend":"PO_So"};